import React, { useEffect, useRef, useState } from "react";
import {
  Avatar, Button, Checkbox, Form,
  // Divider, Card,
  Modal, notification, Popconfirm, Select, Skeleton, Space,
} from "antd";
import moment from "moment/moment";
import "../CallForFacultyCards/CallForFaculty/CallForFacultyClassItem/styles.scss";
import iconDown from "images/icon-linkedin.svg";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import httpClient from "../../../api/module/httpClient";
import { convertToLocalTime } from "../../../utils/format";
import { CustomButton, CustomInput, FroalaEdit, InputBlog } from "../../../components";
import NoItemsMessageCard from "../../../components/NoItemsMessageCard";
import form from "../../Journey/Form";
import { searchUser } from "api";
const { Option } = Select;
// import MoreInfo from "./MoreInfo";
// import linkedInIcon from "../../../../../images/icon-linkedin.svg";
// import IconMail from "../../../../../images/icon-mail-outline.svg";
// import PopupSpeakerSummit from "../../../../CertificateDashboard/PopupInstructor";

const MAX_NUM_APPLICANTS = 999;

export default function CallForGuestLecturerClassItem({ item, userProfile, guestLecture = {} }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const contentRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [description, setDescription] = React.useState({
    value: "",
    validateStatus: null,
  });
  const [usersToBeAdded, setUsersToBeAdded] = useState([]);
  const [funcBodyInput, setFuncBodyInput] = useState({});
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [searchedUsers, setSearchedUsers] = useState([])

  const timezone = userProfile?.timezone;

  const { data: facultyList, isLoading } = useQuery({
    queryKey: ["CLASS_GUEST_LECTURER_LIST", guestLecture.id],
    queryFn: async () => {
      const { data } = await httpClient.get(`private/certificate-class/${guestLecture.id}/guest-lecturer`);

      return data;
    },
    enabled: !!guestLecture?.id,
  });


  const queryClient = useQueryClient();

  const joinMutation = useMutation({
    mutationFn: async ({ classTitle, classDescription }) => {
      const certificateClassId = guestLecture.id;
      return await httpClient.post(`private/certificate-class/${certificateClassId}/guest-lecturer`, {
        classTitle,
        classDescription: classDescription,
      });
    },
    onSuccess:  async ({ data }) => {
      await queryClient.invalidateQueries(["CLASS_GUEST_LECTURER_LIST", guestLecture.id]);

      if (data.type === "EXCEEDED") {
        notification.info({
          message: "Class has exceeded the number of applicants",
        });

        return;
      }


      setIsModalOpen(false);
      // setChecked(false);

      notification.success({
        message: "Success",
      });
    },
    onError: () => {
      notification.error({
        message: "Something went wrong.",
      });
    },
  });

  const updateStatusMutation = useMutation({
    mutationFn: async ({ status }) => {
      const certificateClassId = guestLecture.id;
      await httpClient.patch(`private/certificate-class/${certificateClassId}/faculty`, { status });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["CLASS_FACULITY_LIST", guestLecture.id]);
      notification.success({
        message: "Success",
      });
    },
    onError: () => {
      notification.error({
        message: "Something went wrong.",
      });
    },
  });

  const isFaculty = (facultyList || []).find(faculty => faculty.UserId === userProfile?.id);

  const getButtonText = () => {
    if ((facultyList?.length ?? []) === 10) return "FULL";
    if (isFaculty) return "WITHDRAW";
    return "APPLY HERE";
  };

  const actionMutation = useMutation({
    mutationFn: async ({ userId, type }) => {

      if (!type) throw new Error("No type chosen");

      return httpClient.post(`private/certificate-class/${guestLecture.id}/guest-lecturer/${type}`, { userId });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["CLASS_GUEST_LECTURER_LIST", guestLecture.id]);
      queryClient.invalidateQueries(["MY_FACULTY_DASHBOARD", userProfile?.id]);
      queryClient.invalidateQueries(["MY_FACULTY_DASHBOARD_PAST", userProfile?.id]);
      notification.success({
        message: "Success",
      });
    },
  });

  let startDate = convertToLocalTime(item.startDate, item.timezone);
  let startTime = convertToLocalTime(item.startTime, item.timezone);
  let endTime = convertToLocalTime(item.endTime, item.timezone);
  const guestLectureStartTime = convertToLocalTime(guestLecture.startTime, item.timezone)
  const guestLectureEndTime = convertToLocalTime(guestLecture.endTime, item.timezone)

  const [lectureForm] = Form.useForm();

  const handleSubmit = (values) => {

    let response = funcBodyInput.data();

    values["classDescription"] = response.body;

    joinMutation.mutate(values);
  };

  // const { data: s3Hash } = useQuery({
  //   queryKey: ["S3_EDITOR_SIGNATURE"],
  //   queryFn: async () => {
  //     const response = await httpClient.get("public/env/editor");

  //     return response.data.s3Hash;
  //   },
  // });

  const validateDescription = (value) => {
    if (value.length > 0)
      return {
        validateStatus: "success",
      };

    return {
      validateStatus: "error",
    };
  };

  const onChangeDescription = (e) => {
    const result = { ...validateDescription(e.html), value: e.html }

    setDescription(result);
    // onChange(result)
  }


  const isAdmin = ["enrique@hackinghr.io", "danielle@hackinghr.io", "lourencelinao13@gmail.com"].includes(userProfile?.email)

  return (
    <div className="call-for-faculty-class-item">
      <Space direction="vertical" style={{ width: "100%" }}>
        <h3>{item.title}</h3>
        <div dangerouslySetInnerHTML={{ __html: item?.descriptionForCertificate }}></div>
        <h5>Class Date: {`${(startDate || moment())?.format("LL")}`}</h5>
        <h5>Class Start Time: {(startTime || moment())  .format("HH:mm a")}{" "}{moment.tz.guess()}</h5>
        <h5>Class End Time: {(endTime || moment())?.format("HH:mm a")}{" "}{moment.tz.guess()}</h5>
        <h5>Approved
          Faculty: {item.CertificateClassInstructors?.map(instructor => [instructor.firstName, instructor.lastName].join(" ")).flatMap(i => i).join(", ")}</h5>
        <h5>Guest Lecture Date: {`${guestLectureStartTime.format("LL")}`}</h5>
        <h5>Guest Lecture Start Time: {guestLectureStartTime.format("HH:mm a")}{" "}{moment.tz.guess()}</h5>
        <h5>Guest Lecture End Time: {guestLectureEndTime.format("HH:mm a")}{" "}{moment.tz.guess()}</h5>

        <Modal
          destroyOnClose={true}
          mask={false}
          maskClosable={false}
          open={isModalOpen}
          onCancel={() => {
            setIsModalOpen(false);
            // setChecked(false);
          }}
          width={720}
          onOk={() => {
            lectureForm.submit();
          }}>
          {/*<div>This is a modal</div>*/}
          <div>
            <Form form={lectureForm} layout="vertical" onFinish={handleSubmit}>
              <Form.Item
                label={"Lecture Title"}
                name={"classTitle"}
                rules={[
                  {
                    required: true,
                    message: "Please enter your first name!",
                  },
                ]}
              >
                <CustomInput />
              </Form.Item>
              <Form.Item
                label={"Lecture Description"}
                name={"classDescription"}
                rules={[
                  {
                    required: true,
                    message: "Please enter your description!",
                  },
                ]}
              >
                {/*<CustomInput multiple={true} />*/}
                {/*<FroalaEdit*/}
                {/*  s3Hash={s3Hash}*/}
                {/*/>*/}
                <InputBlog functionData={(e) => setFuncBodyInput(e)} />
              </Form.Item>
            </Form>
          </div>
        </Modal>

        {!isLoading && (
          <Popconfirm
            title={"Are you sure you want to withdraw?"}
            disabled={!isFaculty}
            onConfirm={() => {
              if (isFaculty) {
                updateStatusMutation.mutate({ status: "withdrawn" });
              }
            }}
          >
            {!isFaculty && (
              <CustomButton
                text={getButtonText()}
                type={isFaculty ? "third" : "primary"}
                size="small"
                onClick={() => {
                  if (!isFaculty) setIsModalOpen(true);
                }}
                disabled={(facultyList?.length ?? []) === MAX_NUM_APPLICANTS}
                loading={joinMutation.isLoading}
              />
            )}
          </Popconfirm>
        )}

        <button
          className="expand-button"
          onClick={() => setIsExpanded(prev => !prev)}
        >
          {isExpanded ? "Less information" : "More information"}
        </button>

        <div
          className={`expandable-content ${isExpanded ? "expanded" : ""}`}
          ref={contentRef}
          style={{
            maxHeight: isExpanded ? `${contentRef.current?.scrollHeight}px` : "0",
          }}
        >
          {isLoading && <Skeleton />}

          {(facultyList || []).length === 0 && (
            <NoItemsMessageCard
              message="There are no faculty members in this class."
            />
          )}

          <div className="faculty-list">
            {(facultyList || []).filter(faculty => faculty.status === "confirmed").map(faculty => {
              let caseLink = (faculty.User?.personalLinks?.linkedin?.substring(0, 7) !== "http://" && faculty.User?.personalLinks?.linkedin?.substring(0, 8) !== "https://")
                ? `https://${faculty.User?.personalLinks?.linkedin}`
                : faculty.User?.personalLinks?.linkedin;

              if (caseLink?.substring(0, 14) === "http://http://") {
                caseLink = caseLink.substring(7, caseLink.length);
              }

              if (caseLink?.substring(0, 16) === "https://https://") {
                caseLink = caseLink.substring(8, caseLink.length);
              }

              return (
                <div key={faculty.User.id} className="faculty-item">
                  <div className="faculty-header">
                    <div style={{ width: "min-content" }}>
                      <Avatar src={faculty.User?.img || faculty.img} />
                    </div>
                    <div>
                      <h3>
                        {faculty.User.firstName} {faculty.User.lastName}
                        {faculty.status === "pending" && <span>- PENDING</span>}
                        {(faculty.allowCoFaculty && userProfile.role === "admin") && <span>- Allows Co-faculty</span>}
                      </h3>
                      <h5>{faculty.User.titleProfessions}</h5>
                      <a
                        href={caseLink || "#"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className={"module-icon-linkedin"}
                          src={iconDown}
                          alt="linkedin"
                        />
                      </a>
                      <p>Title: {faculty.CourseClass.title}</p>
                      <p style={{ width: "50%", whiteSpace: "pre-wrap" }}>Description: <span
                        dangerouslySetInnerHTML={{ __html: faculty.CourseClass.description }} /></p>
                    </div>
                  </div>

                  {isAdmin && (
                    <div className="admin-actions">
                      <Popconfirm
                        title={"Are you sure you want to remove this user?"}
                        onConfirm={() => actionMutation.mutate({
                          userId: faculty.User.id,
                          type: "remove",
                        })}
                      >
                        <CustomButton
                          text="Remove"
                          type="third"
                          size="small"
                          style={{ width: "100%" }}
                          loading={actionMutation.isLoading}
                        />
                      </Popconfirm>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="faculty-list" style={{ marginTop: "3rem" }}>
            {(facultyList || []).filter(faculty => faculty.status === "pending").map(faculty => {
              let caseLink = (faculty.User?.personalLinks?.linkedin?.substring(0, 7) !== "http://" && faculty.User?.personalLinks?.linkedin?.substring(0, 8) !== "https://")
                ? `https://${faculty.User?.personalLinks?.linkedin}`
                : faculty.User?.personalLinks?.linkedin;

              if (caseLink?.substring(0, 14) === "http://http://") {
                caseLink = caseLink.substring(7, caseLink.length);
              }

              if (caseLink?.substring(0, 16) === "https://https://") {
                caseLink = caseLink.substring(8, caseLink.length);
              }
              return (
                <div key={faculty.User.id} className="faculty-item">
                  <div className="faculty-header">
                    <div style={{ width: "min-content" }}>
                      <Avatar src={faculty.User?.img || faculty.img} />

                    </div>
                    <div>
                      <h3>
                        {faculty.User.firstName} {faculty.User.lastName}
                        {faculty.status === "pending" && <span>- PENDING</span>}
                        {(faculty.allowCoFaculty && userProfile.role === "admin") && <span>- Allows Co-faculty</span>}
                      </h3>
                      <h5>{faculty.User.titleProfessions}</h5>
                      <a
                        href={caseLink || "#"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className={"module-icon-linkedin"}
                          src={iconDown}
                          alt="linkedin"
                        />
                      </a>
                      <p>Title: {faculty.classTitle}</p>
                      <p style={{ width: "50%", whiteSpace: "pre-wrap" }}>Description: <span
                        dangerouslySetInnerHTML={{ __html: faculty.CourseClass.description }} /></p>
                    </div>
                  </div>

                  {["enrique@hackinghr.io", "danielle@hackinghr.io", "lourencelinao13@gmail.com"].includes(userProfile?.email) && (
                    <div className="admin-actions">
                      <div className="pending-actions">
                        <Popconfirm
                          title={"Are you sure you want to approve this user?"}
                          onConfirm={() => {
                            actionMutation.mutate({
                              userId: faculty.User.id,
                              type: "approve",
                            });
                          }}
                        >
                          <CustomButton
                            text="Approve"
                            type="secondary"
                            size="small"
                            loading={actionMutation.isLoading}
                            style={{ width: "150px" }}
                          />
                        </Popconfirm>
                        <Popconfirm
                          title={"Are you sure you want to reject this user?"}
                          onConfirm={() => {
                            actionMutation.mutate({
                              userId: faculty.User.id,
                              type: "reject",
                            });
                          }}
                        >
                          <CustomButton
                            text="Reject"
                            type="third"
                            size="small"
                            loading={actionMutation.isLoading}
                            style={{ width: "150px" }}
                          />
                        </Popconfirm>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </Space>
    </div>
  );
}